import * as React from "react";
import { Dismiss20Regular, Home20Regular, ReOrderDotsVertical20Regular } from "@fluentui/react-icons";
import { BRAND } from "../../risikoanalyseStep/tokens";
import { beendeZurueckziehen, beginneZurueckziehen } from "./zurueckziehen";

/**
 * Kopfzeile im ausgelagerten Browserfenster — dieselbe Leiste wie oben am
 * KMVS-Fenster, aber ohne Minimieren/Maximieren (das übernimmt der Browser).
 *
 * „Zurück in KMVS“ schließt das Fenster und macht aus dem Browserfenster ein
 * eigenes KMVS mit dem Dashboard (User 27.10.2026). Zurück ins Hauptfenster
 * kommt das Fenster, indem man die Leiste auf das Hauptfenster zieht
 * (`zurueckziehen.ts`).
 */
export const BrowserFensterKopf: React.FC<{
  fensterId: string;
  titel: string;
  icon?: React.ReactNode;
  hell?: boolean;
  onKmvsZeigen: () => void;
  onSchliessen: () => void;
}> = ({ fensterId, titel, icon, hell, onKmvsZeigen, onSchliessen }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      columnGap: 8,
      padding: "6px 6px 6px 8px",
      background: hell ? "#7d2169" : BRAND.purple,
      color: BRAND.white,
      userSelect: "none",
    }}
  >
    <style>{KOPF_CSS}</style>
    <span
      className="kmvs-bf-griff"
      draggable
      onDragStart={(e) => beginneZurueckziehen(fensterId, e.dataTransfer)}
      onDragEnd={beendeZurueckziehen}
      title="Zum Zurückholen diese Leiste ins KMVS-Hauptfenster ziehen"
    >
      <ReOrderDotsVertical20Regular className="kmvs-bf-punkte" />
      {icon && <span style={{ display: "inline-flex", alignItems: "center", color: BRAND.gold }}>{icon}</span>}
      <span
        style={{
          minWidth: 0,
          fontFamily: BRAND.fontAccent,
          fontSize: "1rem",
          fontWeight: 500,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {titel}
      </span>
    </span>
    <button
      type="button"
      className="kmvs-bf-knopf kmvs-bf-text"
      onClick={onKmvsZeigen}
      title="Schließt dieses Fenster und zeigt hier KMVS mit dem Dashboard"
    >
      <Home20Regular />
      Zurück in KMVS
    </button>
    <button type="button" className="kmvs-bf-knopf kmvs-bf-zu" onClick={onSchliessen} aria-label="Schließen" title="Schließen">
      <Dismiss20Regular />
    </button>
  </div>
);

const KOPF_CSS = `
.kmvs-bf-knopf { appearance: none; cursor: pointer; background: transparent; color: ${BRAND.white};
  border: 0; border-radius: 6px; height: 32px; min-width: 32px; display: inline-flex; align-items: center;
  justify-content: center; column-gap: 6px; flex-shrink: 0; font-family: ${BRAND.fontPrimary}; font-size: 0.85rem;
  transition: background-color 120ms, color 120ms; }
.kmvs-bf-knopf:hover { background: rgba(255,255,255,0.12); color: ${BRAND.gold}; }
.kmvs-bf-knopf:focus-visible { outline: 2px solid ${BRAND.gold}; outline-offset: 1px; }
.kmvs-bf-text { padding: 0 10px; }
.kmvs-bf-zu:hover { background: #a1331c; color: ${BRAND.white}; }
.kmvs-bf-griff { flex-grow: 1; min-width: 0; display: inline-flex; align-items: center; column-gap: 8px;
  align-self: stretch; padding-left: 2px; border-radius: 6px; cursor: grab; }
.kmvs-bf-griff:active { cursor: grabbing; }
.kmvs-bf-punkte { flex-shrink: 0; opacity: 0.55; }
.kmvs-bf-griff:hover .kmvs-bf-punkte { opacity: 1; color: ${BRAND.gold}; }
`;
